import { getDeviations, activeElements } from './elementShape';

// Geometrie des Maßkettendiagramms (aus MassketteDiagram herausgelöst,
// damit sie testbar ist). C5: inaktive Maße werden am aktuellen
// Kettenende als „Geist“ gezeichnet, rücken es aber nicht weiter und
// zählen nicht zum Schließmaß.
export function layoutChain(elements, view) {
  if (!elements.length) {
    return { items: [], m0Data: null, minX: 0, span: 1, levelCount: 1 };
  }
  let currentX = 0;
  const items = elements.map((r, i) => {
    const sign = r.direction === -1 ? -1 : 1;
    const nominal = Number(r.nominal) || 0;
    const { lower, upper } = getDeviations(r);
    const lengthValue = view === 'toleranz' ? upper + Math.abs(lower) : nominal;
    const length = lengthValue * sign;
    const start = currentX;
    const end = start + length;
    const inactive = r.inactive === true;
    if (!inactive) currentX = end;
    return {
      id: r.id, index: i,
      name: r.name, label: `M${i + 1}`,
      start, end, sign, nominal,
      upper, lower,
      isPositive: sign > 0,
      inactive,
    };
  });
  const m0Data = { id: 'm0', label: 'M₀', start: 0, end: currentX, isM0: true };

  // Greedy pack (unverändert aus MassketteDiagram): M₀ zuerst, dann die
  // Kettenglieder auf die niedrigste freie Ebene.
  const all = [m0Data, ...items];
  const taken = [];
  all.forEach((item) => {
    const left = Math.min(item.start, item.end);
    const right = Math.max(item.start, item.end);
    let lvl = 0;
    while (true) {
      if (!taken[lvl]) { taken[lvl] = []; break; }
      const collide = taken[lvl].some((o) => {
        const oL = Math.min(o.start, o.end);
        const oR = Math.max(o.start, o.end);
        return left < oR && right > oL;
      });
      if (!collide) break;
      lvl++;
    }
    item.level = lvl;
    taken[lvl].push(item);
  });
  const allX = items.flatMap((i) => [i.start, i.end]).concat([0, m0Data.end]);
  const minX = Math.min(...allX);
  const maxX = Math.max(...allX);
  const span = Math.max(maxX - minX, 0.001);
  return { items, m0Data, minX, span, levelCount: taken.length };
}

export function closureSummary(elements) {
  let nominal = 0, tolU = 0, tolL = 0;
  for (const r of activeElements(elements)) {
    const sign = r.direction === -1 ? -1 : 1;
    nominal += sign * (Number(r.nominal) || 0);
    const { lower, upper } = getDeviations(r);
    if (sign > 0) { tolU += upper; tolL += lower; }
    else { tolU += -lower; tolL += -upper; }
  }
  return { nominal, tolU, tolL, sym: Math.abs(tolU + tolL) < 1e-6 };
}
